import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2xs10,
    GridItem2xs10NotIsXsDownScreen,
    GridItem3xs10,
    GridItem3xs10NotIsXsDownScreen,
    GridItem4,
    GridItem6,
    GridItem8,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoFinanciamentoList from '../../../business-rules/List/tipoFinanciamentoList'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoFinanciamento,
    rowPertentePageFinanciamento,
    setPageInclusaoFinanciamento,
    Familiar,
    TipoFinanciamento,
    IconButtonClearEntradaDadosFinanciamento,
    ValorParcela,
    QtdeParcelas,
    ValorTotalParcelas,
    ValorSaldoDevedor,
    TemSeguro,
    PercSeguroCliente,
    PercSeguroConjuge,
    DescricaoOutros,
} from '../despesas-form/DespesasCompFinanciamento'

import {
    incrementaContFinanciamento,
    processaRegistrosDefaultIniciaisFinanciamento,
    calculaTotaisFinanciamento,
} from '../despesas-form/DespesasServiceFinanciamento'

import {
    processaFormRegistrosDefaultIniciaisSortAscFamiliar
} from './FormService'

import DespesasFormFinanciamentoItem from '../despesas-form/DespesasFormFinanciamentoItem'



const FormFormFinanciamento = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca,
    title }) => {

    const [expandiu, setExpandiu] = useState(false)

    calculaTotaisFinanciamento(values)

    useSingleton(async () => {

        processaFormRegistrosDefaultIniciaisSortAscFamiliar(values, values.totalFinanciamento, processaRegistrosDefaultIniciaisFinanciamento,
            values.financiamento)

        values.pageFinanciamento = obtemPage(values.pageFinanciamentoList, HARDCODE.idFamiliarPage)
    })

    salvaPage(values.pageFinanciamento, values.pageFinanciamentoList, HARDCODE.idFamiliarPage)

    values.financiamentoPagination = values.financiamento

    const isXsDownScreen = IsXsDownScreen()



    return (
        <FieldArray name="financiamento">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.financiamento?.map((item, ind) => {

                            if (rowPertentePageFinanciamento(values, ind)) {

                                let tipoFinanciamentoSelecionado = pesquisaList(tipoFinanciamentoList, item.tipoFinanciamento)

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem3xs10>
                                                <GridContainer>
                                                    <GridItem6>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem6>
                                                    <GridItem6>
                                                        <TipoFinanciamento
                                                            TextFieldNumberSelectTipoFinanciamento={
                                                                TextFieldNumberSelect
                                                            }
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem3xs10>

                                            {item.tipoFinanciamento
                                                ?
                                                    <GridItem2xs10>
                                                        <GridContainer>
                                                            <GridItem8>
                                                                <ValorParcela
                                                                    item={item}
                                                                    ind={ind}
                                                                    label={
                                                                        item.tabelaSAC
                                                                            ?
                                                                                LABEL.valorParcelaAtual
                                                                            :
                                                                                LABEL.valorParcela
                                                                    }
                                                                    handleChange={handleChange}
                                                                    disabled={item.tabelaSAC || expandiu}
                                                                />
                                                            </GridItem8>
                                                            <GridItem4>
                                                                <QtdeParcelas
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    label={LABEL.qtdeParcelasAbreviado}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem4>
                                                        </GridContainer>
                                                    </GridItem2xs10>
                                                :
                                                    <GridItem2xs10NotIsXsDownScreen/>
                                            }

                                            
                                            {item.valorTotalParcelas !== 0
                                                ?
                                                    <GridItem3xs10>
                                                        <GridContainer>
                                                            <GridItem6>
                                                                <ValorTotalParcelas
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                />
                                                            </GridItem6>
                                                            {item.valorSaldoDevedor && (
                                                                <GridItem6>
                                                                    <ValorSaldoDevedor
                                                                        TextValidatorValorValorSaldoDevelor={
                                                                            TextValidatorValor
                                                                        }
                                                                        values={values}
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                        expandiu={expandiu}
                                                                    />
                                                                </GridItem6>
                                                            )}
                                                        </GridContainer>
                                                    </GridItem3xs10>
                                                :
                                                    <GridItem3xs10NotIsXsDownScreen/>
                                            }

                                            {item.tipoFinanciamento
                                                ?
                                                    <GridItem3xs10>
                                                        <GridContainer>
                                                            <GridItem4>
                                                                {item.tipoFinanciamento && tipoFinanciamentoSelecionado.informaTemSeguro === "S" && (
                                                                    <TemSeguro
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                        expandiu={expandiu}
                                                                    />
                                                                )}
                                                            </GridItem4>
                                                            {item.temSeguro === "S" &&
                                                            (
                                                                item.familiar === HARDCODE.idFamiliarCliente ||
                                                                item.familiar === HARDCODE.idFamiliarConjuge
                                                            )
                                                                ?
                                                                    <>
                                                                        <GridItem4>
                                                                            <PercSeguroCliente
                                                                                values={values}
                                                                                item={item}
                                                                                ind={ind}
                                                                                handleChange={handleChange}
                                                                                expandiu={expandiu}
                                                                            />
                                                                        </GridItem4>
                                                                        <GridItem4>
                                                                            <PercSeguroConjuge
                                                                                values={values}
                                                                                item={item}
                                                                                ind={ind}
                                                                                handleChange={handleChange}
                                                                                expandiu={expandiu}
                                                                            />
                                                                        </GridItem4>
                                                                    </>
                                                                :
                                                                    <GridItem8>
                                                                        <DescricaoOutros
                                                                            item={item}
                                                                            ind={ind}
                                                                            handleChange={handleChange} 
                                                                            expandiu={expandiu}
                                                                        />
                                                                    </GridItem8>
                                                            }
                                                        </GridContainer>
                                                    </GridItem3xs10>
                                                :
                                                    <GridItem3xs10NotIsXsDownScreen/>
                                            }

                                            <GridItem1xs2>
                                                <GridContainer>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <CustomizedDialogsPopup
                                                            maxWidth="sm"
                                                            popupTitle={title}
                                                            tooltipTitle={LABEL.expandir}
                                                            PopupButton={IconButtonMaisInformacoes}
                                                            popupButtonDestaque={false}
                                                            DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                                                            popupComponent={
                                                                <DespesasFormFinanciamentoItem
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={arrayHelpers}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    tipoFinanciamentoSelecionado={
                                                                        tipoFinanciamentoSelecionado
                                                                    }
                                                                    item={item}
                                                                    ind={ind}
                                                                    simplificado={true}
                                                                />
                                                            }
                                                            open={setExpandiu}
                                                            afterClose={setExpandiu}
                                                        />
                                                    </GridItem6>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <IconButtonClearEntradaDadosFinanciamento
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            ind={ind}
                                                            arrayHelpers={arrayHelpers}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem1xs2>
                                        </GridContainer>
                                        
                                        {isXsDownScreen && values.financiamentoPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoFinanciamento
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    <GridContainerGridItemButtonIncluirLinha>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirFinanciamento} 
                            align='right'
                            disabled={familiaresList(values).length === 0 ? true : false}
                            onClick={() =>
                                {
                                    incrementaContFinanciamento(values)
                                    arrayHelpers.push({
                                        id: values.contFinanciamento,
                                        familiar: HARDCODE.idFamiliarCliente
                                    })
                                    setPageInclusaoFinanciamento(values, setFieldValue)
                                }
                            }
                        />
                    </GridContainerGridItemButtonIncluirLinha>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormFinanciamento